import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { BehaviorSubject, interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ServiceTicketCallNowDetails, ServiceTicketStore } from '../../../../../@store';
import { CommonStandaloneModule } from '../../../../common-standalone.module';
import { FormatPhoneNumberPipe } from '../../../../pipes';
import { UIService } from '@services';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-service-ticket-call-result',
  standalone: true,
  imports: [CommonStandaloneModule, MatButtonModule, MatIconModule, FormatPhoneNumberPipe],
  templateUrl: './service-ticket-call-result.component.html',
  styleUrls: ['./service-ticket-call-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketCallResultComponent implements OnInit, OnDestroy {
  callNowDetails: ServiceTicketCallNowDetails;
  time$: BehaviorSubject<string>;
  seconds: number;

  private ngUnsubscribe$ = new Subject<void>();
  constructor(public serviceTicketStore: ServiceTicketStore, protected uiService: UIService) {}

  ngOnInit(): void {
    this.serviceTicketStore.callNowDetails$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((_callNowDetails) => {
        this.callNowDetails = _callNowDetails;
        this.countDown();
      });
  }

  onCallNowClicked(): void {
    this.serviceTicketStore.requestCallNow();
  }

  private countDown(): void {
    this.seconds = 5 * 60;
    this.time$ = new BehaviorSubject(this.getRemainingTime());

    interval(1000)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(() => {
        this.seconds -= 1;
        this.time$.next(this.getRemainingTime());
        if (this.seconds < 1) {
          this.clearInterval();
          this.serviceTicketStore.callNowTimeExpired();
        }
      });
  }

  private getRemainingTime(): string {
    const m = Math.floor(this.seconds / 60);
    let s: number | string = this.seconds % 60;
    s = s < 10 ? `0${s}` : s;

    return `${m}:${s}`;
  }

  private clearInterval(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  ngOnDestroy(): void {
    this.clearInterval();
  }
}
